'use strict';
let base = require('./base');

const formValidation = require('base/components/formValidation');
const notification = require('../components/notification');
const r = document.querySelector(':root');
const clientSideValidation = require('../components/clientSideValidation');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

function generalCoursePDP() {
    $('body').on('change', 'select.form-control', function (e) {
        var $form = $(e.target).parents('form');
        if ($form.length) {
            clientSideValidation.functions.clearForm($form);
            clientSideValidation.functions.validateForm($form, null);
        }
    });
    let $form = $('.js-general-course-form');
    $(document).on('click', '.js-general-course-form button[type=submit]', function (e) {
        e.preventDefault();
        let url = $form.attr('action');
        var formValidate = clientSideValidation.functions.validateForm($form, null);
        if (url && formValidate) {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                beforeSend: $form.spinner().start,
                complete: $form.spinner().stop,
                success: function (data) {
                    if (!data.success) {
                        if (data.loggedin) {
                            if (data.errorMessage) {
                                notification.createErrorNotification(data.errorMessage);
                            } else {
                                formValidation($form, data);
                            }
                        } else {
                            $('#loginBtn').trigger('click');
                        }
                    } else {
                        $('.fake.product-detail').removeClass('d-none ');
                        $('.original.product-detail').addClass('d-none');
                        $('html, body').animate({ scrollTop: 0 }, 'slow');
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
        }
    });
}

function toddlersAction() {
    $('body').on('click', '.toddlers-actions .increase-qty', function (e) {
        e.preventDefault();
        var currentQty = parseInt($(this).parents('.toddlers-actions').find('.addons-qty-input').val());
        var maxAmount = parseInt($(this).parents('.product-option').find('.options-select option').length) - 1;
        if (currentQty < maxAmount) {
            var nextQty = currentQty + 1;
            $(this).parents('.product-option').find('.options-select').prop('selectedIndex', nextQty)
                .selectric('refresh')
                .trigger('change');
            $(this).parents('.product-option').find('.addons-qty-input').removeClass('addons-qty-input-empty-value')
                .val(nextQty);
        }
    });

    $('body').on('click', '.toddlers-actions .decrease-qty', function (e) {
        e.preventDefault();
        var currentQty = parseInt($(this).parents('.toddlers-actions').find('.addons-qty-input').val());
        if (currentQty > 0) {
            var nextQty = currentQty - 1;
            $(this).parents('.product-option').find('.options-select').prop('selectedIndex', nextQty)
                .selectric('refresh')
                .trigger('change');
            $(this).parents('.product-option').find('.addons-qty-input').removeClass('addons-qty-input-empty-value')
                .val(nextQty);
        }
    });
}

function addonsAction() {
    $('body').on('click', '.addon-actions .increase-qty', function (e) {
        e.preventDefault();
        var $qtyInput = $(this).parents('.addon-actions').find('.addons-qty-input');
        var currentQty = parseInt($qtyInput.val());
        var pricePerItem = $(this).parents('.product-info').find('.total-amount-of-addon').data('price-per-item');
        var maxAmount = $qtyInput.attr('data-addonmaxqty') || 5;
        if (currentQty < maxAmount) {
            var nextQty = currentQty + 1;
            var totalPrice = pricePerItem * nextQty;
            $(this).parents('.product-info').find('.total-count').text(totalPrice);
            $(this).parents('.product-info').find('.total-amount-text').removeClass('total-amount-text-empty');
            if (currentQty === 0) {
                $(this).parents('.product-info').find('.js-related-product-select').trigger('click');
                $(this).parents('.product-info').find('.decrease-qty').removeClass('qty-disabled')
                    .find('.svg-icon-second')
                    .removeClass('disabled');
            } else {
                $(this).parents('.product-info').find('.quantity-select').prop('selectedIndex', currentQty)
                    .selectric('refresh');
                $(this).parents('.product-info').find('.js-related-product-select')
                    .prop('checked', false)
                    .attr('checked', false)
                    .trigger('click');
            }
            $(this).parents('.addon-actions').find('.addons-qty-input').removeClass('addons-qty-input-empty-value')
                .val(nextQty);
        }

        if (currentQty === maxAmount - 1) {
            $(this).addClass('qty-disabled').find('.svg-icon-second').addClass('disabled');
        }
    });

    $('body').on('click', '.addon-actions .decrease-qty', function (e) {
        e.preventDefault();
        var currentQty = parseInt($(this).parents('.addon-actions').find('.addons-qty-input').val());
        var nextQty = currentQty - 1;
        var pricePerItem = $(this).parents('.product-info').find('.total-amount-of-addon').data('price-per-item');
        if (currentQty > 1) {
            $(this).parents('.product-info').find('.quantity-select').prop('selectedIndex', currentQty - 2)
                .selectric('refresh');
            $(this).parents('.product-info').find('.js-related-product-select')
                .prop('checked', false)
                .attr('checked', false)
                .trigger('click');
            $(this).parents('.addon-actions').find('.addons-qty-input').val(nextQty);
            var totalPrice = pricePerItem * nextQty;
            $(this).parents('.product-info').find('.total-count').text(totalPrice);
        }

        if (currentQty === 1) {
            $(this).parents('.product-info').find('.js-related-product-select').trigger('click');
            $(this).parents('.addon-actions').find('.addons-qty-input').addClass('addons-qty-input-empty-value')
                .val(nextQty);
            $(this).addClass('qty-disabled').find('.svg-icon-second').addClass('disabled');
            $(this).parents('.product-info').find('.total-amount-text').addClass('total-amount-text-empty')
                .find('.total-count')
                .text('0');
        }

        if (currentQty === 10) {
            $(this).parents('.product-info').find('.increase-qty').removeClass('qty-disabled')
                .find('.svg-icon-second')
                .removeClass('disabled');
        }
    });
}

function showBiggerImage() {
    var htmlString = '';
    $('.product-wrapper-inner').on('click', '.pdp-image', function () {
        htmlString =
            `<div class="modal fade" id="pdpImageModal" tabindex="-1" role="dialog">
                <div class="modal-dialog choose-bonus-product-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-body p-0">
                            <button type="button" class="close svg-icon-second" data-dismiss="modal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.45613 0.401017C2.18669 0.140791 1.82583 -0.00320088 1.45127 5.40037e-05C1.0767 0.00330889 0.718397 0.15355 0.453528 0.418419C0.188659 0.683288 0.038418 1.04159 0.0351631 1.41616C0.0319082 1.79072 0.1759 2.15159 0.436126 2.42102L7.99755 9.98245L0.436126 17.5439C0.299683 17.6757 0.190851 17.8333 0.115981 18.0076C0.0411112 18.1819 0.00170225 18.3693 5.39382e-05 18.559C-0.00159437 18.7487 0.0345509 18.9368 0.106381 19.1124C0.178211 19.2879 0.284286 19.4474 0.418419 19.5816C0.552551 19.7157 0.712054 19.8218 0.88762 19.8936C1.06319 19.9654 1.2513 20.0016 1.44098 19.9999C1.63067 19.9983 1.81813 19.9589 1.99242 19.884C2.16671 19.8092 2.32434 19.7003 2.45613 19.5639L10.0176 12.0024L17.579 19.5639C17.8484 19.8241 18.2093 19.9681 18.5838 19.9648C18.9584 19.9616 19.3167 19.8113 19.5816 19.5465C19.8465 19.2816 19.9967 18.9233 19.9999 18.5487C20.0032 18.1742 19.8592 17.8133 19.599 17.5439L12.0376 9.98245L19.599 2.42102C19.8592 2.15159 20.0032 1.79072 19.9999 1.41616C19.9967 1.04159 19.8465 0.683288 19.5816 0.418419C19.3167 0.15355 18.9584 0.00330889 18.5838 5.40037e-05C18.2093 -0.00320088 17.8484 0.140791 17.579 0.401017L10.0176 7.96245L2.45613 0.401017Z"/>
                                </svg>
                            </button>
                            <img src="${$(this).attr('src')}" />
                        </div>
                    </div>
                </div>
            </div>`;
        $('body').append(htmlString);
        $('#pdpImageModal').modal('show');
    });

    $('body').on('hidden.bs.modal', '#pdpImageModal', function () {
        $('#pdpImageModal').remove();
        htmlString = '';
    });
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    init: base.init,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            let $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            let enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                let allAvailable = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                let allReady = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            let $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    toggleDescription: function () {
        let descriptionContainer = $('.product-description-text');
        if (descriptionContainer.length === 0) {
            return;
        }
        var offsetHeight = descriptionContainer[0].offsetHeight;
        var scrollHeight = descriptionContainer[0].scrollHeight;

        if (scrollHeight <= offsetHeight) {
            $('.product-read-more').hide();
            $('.product-read-less').hide();
        }

        descriptionContainer.find('p').each(function () {
            var $p = $(this);
            if ($p.is(':empty')) {
                $p.remove();
            }
        });


        $('body').on('click', '.product-read-more', function (e) {
            e.preventDefault();
            $(this).addClass('d-none');
            $('.product-top-description').find('.product-read-less').removeClass('d-none');
            let descriptionHeight = $('.product-description-text')[0].scrollHeight;
            r.style.setProperty('--descriptionContainer', descriptionHeight + 'px');
            $(descriptionContainer).addClass('open');
        }).on('click', '.product-read-less', function (e) {
            e.preventDefault();
            $(this).addClass('d-none');
            $('.product-top-description').find('.product-read-more').removeClass('d-none');
            $(descriptionContainer).removeClass('open');
            r.style.setProperty('--descriptionContainer', '66px');
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    showRestrictionMaodal: function () {
        $('#restrictionModal').modal('show');
    },

    closeRestrictionModal: function () {
        $('a.close-modal').on('click', function (e) {
            e.preventDefault();
            $('#restrictionModal').modal('hide');
        });
    },

    generalCoursePDP: generalCoursePDP,
    addonsAction: addonsAction,
    toddlersAction: toddlersAction,
    showBiggerImage: showBiggerImage
};
